import { onConnect } from '@sonicgarden/onconnect';

onConnect('.js-popover', (element) => {
  $(element).popover({
    sanitize: false,
  });
});
